'use strict';

import analytics from '../analytics';
import dialog from '../dialog';
import modal from '../modal';
import minicart from '../minicart';
import quickview from '../quickview';
import tooltip from '../tooltip';
import rating from '../rating';
import tls from '../tls';
import video from '../video';
import headerMenu from '../header-menu';
import footerSelector from '../footer-selector';
import newsletter from '../newsletter';
import gatedlanding from '../gatedlanding';
import pdpredesign from '../pdpredesign';
import customPDPbundle from '../customized-bundle';
import inputEntry from '../input-entry';
import wishlists from '../pages/beautystation/wishlists';
import deTheme from '../theme';
import validator from '../validator';
import login from '../login';
import newsletterModule from '../newsletter-module';
import skiplinks from '../skiplinks';
import main from '../main';

import jqueryExt from '../jquery-ext';
import cookieprivacy from '../cookieprivacy';
import captcha from '../captcha';

import '../spritespin';

import productDetail from '../productdetail';

jqueryExt();
cookieprivacy();
captcha();

import product from '../pages/product';
import error from '../pages/error';

const pages = {
  product,
  error
};

const app = {
    init: function () {

        $(document).foundation();

        if (document.cookie.length === 0) {
            $('<div></div>').addClass('browser-compatibility-alert').append($('<p></p>').addClass('browser-error').html(Resources.COOKIES_DISABLED)).appendTo('#browser-check');
        }

        main.init();
        main.initializeDom();
        main.initializeEvents();
        main.backToTopHandler();
        main.minimizedHeaderHandler();
        main.responsiveMegaMenu();
        main.searchMenuEvent();

        // init specific global components
        analytics.init();
        gatedlanding.init();
        tooltip.init();
        validator.init();
        headerMenu.init();
        skiplinks.init();
        video.init();
        login.init();
        newsletterModule.init();
        if ($('.pt_checkout').length === 0) {
            minicart.init();
        }

        rating.init();

        if (SitePreferences.IS_MARKET_MAPPING_ENABLED) {
            footerSelector.languageSelector();
            footerSelector.countrySelector();
        }

        newsletter.newsletterHeader();
        newsletter.isNewsletterEnabled();
        newsletter.signUpFooter();
        
        inputEntry.entry();
        main.playVideoHandler();
        pdpredesign.init();
        customPDPbundle.init();

        deTheme.init();

        main.initPageSpecificModule(pages);
        // Check TLS status if indicated by site preference
        if (SitePreferences.CHECK_TLS === true) {
            tls.getUserAgent();
        }

        $('body').trigger('showNewsletterModal');
        wishlists.initPDPAndCartEvents();

        productDetail.init();
        
    }
};

// initialize app
$(function () {
    app.init();
});

// expose global app obj for 3rd party integrations
window.app = {
    quickview: quickview,
    minicart: minicart,
    user: window.User,
    SCemailUrl: window.Urls.SCemailUrl,
    Product: {},
    tagmanager: analytics.tagmanager,
    gtmInternalPromotion: analytics.gtmInternalPromotion,
    modal: modal,
    dialog: dialog,
    deTheme: deTheme
};

// expose global saveURL to support legacy Composed integration
window.saveURL = window.Urls.saveConsultationURL;

// summary scroll bar global scope
window.addSummaryScrollbar = main.addSummaryScrollbar;
window.scrollToTop = main.scrollToTop;